import { ListOperation } from '../components';

export const OperationList = () => {
  return <ListOperation />;
};
